<template>
  <div :class="[$style.container, hostClass]">
    <share-activity-button />
    <ChangeTranscriptionLanguageButton v-if="!isMeetingEnded" />
    <favourite />
    <add-to-playlist-button />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import ShareActivityButton from './share-activity/share-activity-button'
  import ChangeTranscriptionLanguageButton from './ChangeTranscriptionLanguage/ChangeTranscriptionLanguageButton'
  import Favourite from './favourite/favourite'
  import AddToPlaylistButton from './add-to-playlist/add-to-playlist-button'

  const { mapState } = createNamespacedHelpers('activitySummary')

  export default {
    components: {
      ShareActivityButton,
      ChangeTranscriptionLanguageButton,
      Favourite,
      AddToPlaylistButton
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      hostClass () {
        return `host-${this.$_activitySummary_config.hostApp}`
      },
      isMeetingEnded () {
        return ['completed', 'busy', 'no-answer'].includes(this.activity.status)
      }
    }
  }
</script>

<style module lang="less" src="./secondary-actions.less"></style>



// WEBPACK FOOTER //
// secondary-actions.vue?c0d8f6ce